import { render, staticRenderFns } from "./MobileAlert.vue?vue&type=template&id=68f75d6a&scoped=true&"
import script from "./MobileAlert.vue?vue&type=script&lang=js&"
export * from "./MobileAlert.vue?vue&type=script&lang=js&"
import style0 from "./MobileAlert.vue?vue&type=style&index=0&id=68f75d6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f75d6a",
  null
  
)

export default component.exports